/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/app_embed" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbedResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbedResult } from "./validators";

export const getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed,
  (
    signal: AbortSignal,
    appGroupId: string,
    bridgeId: string
  ): Promise<AlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbedResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}/app_embed`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbedResult
);
